import React from "react";
import { IDropdownOptionProps } from "../DropdownOption";
import { ILangOption } from "../Select";
import { SelectOption } from "../SelectOption";
import SvgIcon from "../../../Icons/SvgIcon";

export default function LanguageSwitcherOption({
  item,
  classes,
  variant,
  labelKey,
  valueKey,
  onSelect,
}: IDropdownOptionProps<ILangOption>): JSX.Element {
  return (
    <SelectOption<ILangOption>
      item={item}
      variant={variant}
      classes={classes}
      labelKey={labelKey}
      valueKey={valueKey}
      onSelect={onSelect}
    >
      <div className="d-flex align-items-center">
        <SvgIcon icon={item.icon} classes={{ root: "me-5" }} />
        {item.label}
      </div>
    </SelectOption>
  );
}
